import React, { useState } from 'react';
import { PunchFeature, TaaConfigsContextProvider } from '@amzn/atoz-dashboard-taa-components';
import { DateTime } from 'luxon';
import { QueryClient, QueryClientProvider } from 'react-query';
import { DatePicker } from '@amzn/stencil-react-components/date-picker';
import { Col } from '@amzn/stencil-react-components/layout';
import { WidgetView, WidgetViewProps } from 'src/models/WidgetView';
import { getInitialSelectedDateFromWidgetInput } from 'src/utils/DateTimeUtils';
import { getTAAComponentConfig } from 'src/components/Widgets/WidgetUtils';
import { usePopstarFeatures } from 'src/hooks/usePopstarFeatures';

export interface PunchViewProps extends WidgetViewProps {}

const PunchView: WidgetView = ({ employeeInfo, widgetInfo }: PunchViewProps) => {
  const [date, setDate] = useState<DateTime>(
    getInitialSelectedDateFromWidgetInput(widgetInfo.widgetInputs.SelectedDate),
  );

  const {
    canSubmitMissedPunch,
    ctkPolicy,
    isExtendPunchEligibilityForWebEnabled,
    hasUnverifiedMissedPunchLimit,
    isATPlusTemporalRoutingEnabled,
    isDeleteDupePunchEnabled,
    isDeleteMpcaMpcsForNativeEnabled,
    isDeleteMpcaMpcsForWebEnabled,
    isExtendPunchEligibilityForNativeEnabled,
    isMissedPunchClickableRowForNativeEnabled,
    isMissedPunchClickableRowForWebEnabled,
    isPaycodeDomainAPIEnabled,
    isPendingPunchesOnTimecardEnabled,
    isPunchCorrStatusV1Enabled,
    isPunchEditForNativeEnabled,
    isPunchEditForWebEnabled,
    isSubmitMissedPunchV2Enabled,
    isTimeCardOneClickManagerReviewFeatureEnabled,
    showRoundedPunch,
    useUnifiedPunchesAPIForNative,
    useUnifiedPunchesAPIForWeb,
  } = usePopstarFeatures();

  return (
    <Col padding={'0px'} gridGap={'S200'}>
      <DatePicker
        id="punch-view-date-picker"
        defaultValue={date.toISODate() ?? ''}
        value={date.toISODate() ?? ''}
        onChange={(newDate: string) => {
          setDate(DateTime.fromISO(newDate));
        }}
      />

      <QueryClientProvider client={new QueryClient()}>
        <TaaConfigsContextProvider taaConfigs={getTAAComponentConfig(employeeInfo)}>
          <PunchFeature
            selectedDateTime={date} // Change Selected Time using Context
            militaryTime={false}
            isInTimehubAssistant={true} // Enables styling and other THA related effects
            featureGates={{
              canSubmitMissedPunch,
              ctkPolicy,
              isExtendPunchEligibilityForWebEnabled,
              hasUnverifiedMissedPunchLimit,
              isATPlusTemporalRoutingEnabled,
              isDeleteDupePunchEnabled,
              isDeleteMpcaMpcsForNativeEnabled,
              isDeleteMpcaMpcsForWebEnabled,
              isExtendPunchEligibilityForNativeEnabled,
              isMissedPunchClickableRowForNativeEnabled,
              isMissedPunchClickableRowForWebEnabled,
              isPaycodeDomainAPIEnabled,
              isPendingPunchesOnTimecardEnabled,
              isPunchCorrStatusV1Enabled,
              isPunchEditForNativeEnabled,
              isPunchEditForWebEnabled,
              isSubmitMissedPunchV2Enabled,
              isTimeCardOneClickManagerReviewFeatureEnabled,
              showRoundedPunch,
              useUnifiedPunchesAPIForNative,
              useUnifiedPunchesAPIForWeb,
            }}
          />
        </TaaConfigsContextProvider>
      </QueryClientProvider>
    </Col>
  );
};

export default PunchView;
